import React from "react";

import { Article } from "custom-types/Wordpress";

import NewsFeaturedMedia from "components/news/NewsFeaturedMedia";

import NewsArticleHeader from "../NewsArticleHeader";

const FeaturedArticleHeader: React.FC<{
  article: Article;
}> = ({ article }) => (
  <>
    <NewsFeaturedMedia media={article.featuredMedia} isFeaturedArticle={true} />
    <div className="bg-green">
      <div className="container py-xl text-white">
        <NewsArticleHeader article={article} />
      </div>
    </div>
  </>
);

export default FeaturedArticleHeader;
